import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import toast from "react-hot-toast";

export default function DynamicLinksSettingsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    wishlist_fare_alert_app_link: "",
  });

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/dynamic-links/settings");
      if (res.data?.data) {
        const d = res.data.data;
        setForm({
          wishlist_fare_alert_app_link: d.wishlist_fare_alert_app_link || "",
        });
      }
    } catch (e) {
      toast.error("Failed to load dynamic links settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const onSubmit = async () => {
    try {
      setSaving(true);
      await api.post("/admin/dynamic-links/settings", form);
      toast.success("Dynamic links settings updated successfully!");
    } catch (e) {
      toast.error(e?.response?.data?.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-sm">Loading...</div>;

  return (
    <div className="bg-white rounded-2xl p-6">
      <button
        className="text-sm text-blue-600 font-semibold mb-4"
        onClick={() => navigate("/admin/settings-management")}
      >
        ← Back to Settings
      </button>

      <h1 className="text-2xl font-bold">APP Dynamic Links Settings</h1>
      <p className="text-sm text-gray-500 mt-2">
        Configure deep link URLs used within the mobile application.
      </p>

      <div className="mt-8 space-y-8">
        <div className="border rounded-2xl p-6">
          <h2 className="text-lg font-bold mb-1">Wishlist Fare Alert App Link</h2>
          <p className="text-sm text-gray-500 mb-6">
            Deep link URL opened when users tap a wishlist fare alert notification.
          </p>

          <div>
            <label className="text-base font-semibold block mb-2">App Link</label>
            <input
              type="text"
              className="w-full border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-black text-sm"
              placeholder="e.g. navigatio://wishlist/fare-alert"
              value={form.wishlist_fare_alert_app_link}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  wishlist_fare_alert_app_link: e.target.value,
                }))
              }
            />
          </div>
        </div>
      </div>

      <div className="mt-8">
        <button
          type="button"
          onClick={onSubmit}
          disabled={saving}
          className="bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90 disabled:opacity-50"
        >
          {saving ? "Updating..." : "Update Settings"}
        </button>
      </div>
    </div>
  );
}
